<div class="container-fluid">
    <app-gene-table-selector [showGenomic] = true [showAssembly] = false [showRepseq]=false></app-gene-table-selector>
    <app-gene-table-panel></app-gene-table-panel>
</div>
